










































































import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig, UseModal } from "@/components/root/modal";
import VirtualTable from "@/components/table/VirtualTable.vue";
import { UseFilesCollection } from "./use-files";
import { table_config } from "./table.config";
import {
  computed,
  onBeforeUnmount,
  onMounted,
  Ref,
  ref,
  watch,
} from "@vue/composition-api";
import { EventBus } from "@/eventbus";
import FileTableRow from "./FileTableRow.vue";
import { emptyFn } from "@/fp";
import Filters from "@/components/filters/Filters.vue";
import { create_filters_config } from "@/components/filters/filters.state";
import { FilesModalProps } from "./model";
import { SharedState } from "@/common/state";
import { CoordinateInputTier3, TimeAxisRangeInput } from "@/gql/types";
import AppSwitch from "@/components/AppSwitch.vue";
import { pxToRem, remToPx } from "@/common/dom.functions";
import EventsModalVue from "@/components/modals/events-modal/EventsModal.vue";
import { bus_file_row_menu_listener } from "@/common/event-bus-callbacks/file-row-menu";
import { bus_confidence_listener } from "@/common/event-bus-callbacks/confidence";
import { POPULATION_TYPE } from "@/common/models";
import { UsePopup } from "@/components/root/popup/popup.state";

export default Vue.extend({
  components: {
    Modal,
    VirtualTable,
    Filters,
    AppSwitch,
  },
  props: ["modalData"],
  setup(props, { emit }) {
    const filterCmp: Ref<{
      get_tags: () => Record<string, string | number>;
    } | null> = ref(null);
    const display_as_events = ref(false);
    const time_frame = computed(() => {
      const { from, type } = SharedState.selectedTimeFrameOption.value;
      return { type, values: [from] } as TimeAxisRangeInput;
    });

    const modal_data = computed(() => props.modalData as FilesModalProps);

    const filter_cords: Ref<CoordinateInputTier3[]> = ref([]);

    const {
      items: files,
      is_loading,
      has_more,
      clear: clear_files,
      load_items: load_files,
      load_more_items: load_more,
      has_no_results,
    } = UseFilesCollection(
      () => [...modal_data.value.coordinates, ...filter_cords.value],
      //@ts-ignore
      props.modalData.clusterUID
    );

    const filters_config = create_filters_config(
      "files",
      modal_data.value.coordinates[0]
    );

    if (modal_data.value.hide_filters) {
      modal_data.value.hide_filters.forEach((key) => {
        // @ts-ignore
        filters_config[key].include = false;
      });
    }

    if (SharedState.in_motion_services_flags.value.is_google_org_only) {
      filters_config.sources.only = ["gdrive", "gmail", "gchat"];
    } else if (SharedState.in_motion_services_flags.value.is_ms_org_only) {
      filters_config.sources.only = [
        "onedrive",
        "sharepoint",
        "exchange_365",
        "ms_teams",
      ];
    }

    const modal_config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      backdropDismiss: true,
      width: "115rem",
      height: Math.min(65, pxToRem(innerHeight) * 0.9) + "rem",
    };

    const export_table_as_csv = async (event: MouseEvent) => {
      if (SharedState.is_biz_user.value) {
        if (SharedState.restrictions.is_restricted_app("reports")) {
          SharedState.restrictions.show_restrictions_modal("app", "Reports");
          return;
        }
      }
      const { state: csv_state } = await import(
        "@/views/reports/data/csv/state.csv"
      );
      const payload = {
        possible_call_tags: ["tier3-items", "get_files"],
        table_config,
        title: modal_data.value.files_title,
        tags: {
          ...filterCmp.value!.get_tags(),
          entity_type: POPULATION_TYPE.FILE,
        },
      };

      if (SharedState.FeatureHelper.is_enabled("csv_report_scheduler")) {
        const res = await UsePopup.showActionPopup({
          type: "TextAndIconDisplayPopup",
          items: [
            { icon: "CSV", text: "Generate csv report" },
            { icon: "Calendar", text: "Schedule csv report" },
          ],
          width: remToPx(15),
          event,
          position: "bottom-left",
        });
        if (res.type == "canceled") {
          return;
        }
        if (res.action == "Schedule csv report") {
          // @ts-ignore
          csv_state.schedule_gql_csv_report(payload);
        } else {
          // @ts-ignore
          csv_state.create_gql_report(payload);
        }
      } else {
        // @ts-ignore
        csv_state.create_gql_report(payload);
      }
    };

    const load_more_files = async () => {
      if (has_more.value) {
        await load_more();
      }
    };

    const on_filters_changed = async (
      cords_from_filter: CoordinateInputTier3[]
    ) => {
      filter_cords.value = [...cords_from_filter];
      clear_files();
      await load_files({ cursor: "" });
    };

    const subs = {
      switch: emptyFn(),
      confidence: emptyFn(),
      show_menu: emptyFn(),
      close_all_modals: emptyFn(),
    };

    onMounted(async () => {
      subs.switch = watch(
        display_as_events,
        async () => {
          emit("swap");
          UseModal().show(EventsModalVue, {
            // @ts-ignore
            ...props.modalData,
            hide_backdrop: true,
            transition: "none",
          });
        },
        {
          lazy: true,
        }
      );

      await load_files({ cursor: "" });

      const [file_menu_clicked, handler] = bus_file_row_menu_listener();
      subs.show_menu = EventBus.listen(file_menu_clicked, handler);

      const [conf_event_name, conf_handler] = bus_confidence_listener();
      subs.confidence = EventBus.listen(conf_event_name, conf_handler);
      subs.close_all_modals = EventBus.listen(
        EventBus.GLOBAL_EVENTS.CLOSE_ALL_MODALS,
        () => emit("cancel")
      );
    });

    onBeforeUnmount(() => Object.values(subs).forEach((unsub) => unsub()));

    return {
      filterCmp,
      display_as_events,
      filters_config,
      time_frame,
      modal_config,
      table_config,
      filter_cords,
      FileTableRow,
      is_loading,
      has_no_results,
      files,
      load_more_files,
      has_more,
      export_table_as_csv,
      on_filters_changed,
      has_reports_enabled: SharedState.FeatureHelper.is_enabled("reports"),
    };
  },
});
